<script lang="ts">
  import { onMount } from "svelte";
  import ImportInstallationsPage from "$lib/components/ImportInstallationsPage.svelte";
  import { logger } from "$lib/logger";
  import { API_HOST } from "$lib/environment";
  import { bootstrapToken } from "$lib/stores/bootstrapTokenStore";
  import { exchangeBootstrapToken } from "$lib/authExchange";

  // Accept element attributes as props from the custom element
  let elementAttributes: Record<string, string | undefined> = $props();

  const environment = {
    apiHost: API_HOST,
  };
  let containerAttributes = $derived({
    ...environment,
    ...elementAttributes,
  });

  type AppStatus = "loading" | "authenticating" | "ready";

  let appStatus: AppStatus = $state("loading");
  let handshakeStarted = false;
  let latestBootstrapToken: string | null = null;

  let overlayText = $derived(
    appStatus === "loading" ? "Loading..." : "Authenticating...",
  );

  bootstrapToken.subscribe((token) => {
    latestBootstrapToken = token;
    startHandshake();
  });

  function startHandshake() {
    if (!latestBootstrapToken || handshakeStarted || appStatus === "loading") {
      return;
    }
    handshakeStarted = true;
    exchangeBootstrapToken(latestBootstrapToken)
      .then(() => {
        appStatus = "ready";
        logger.info("BFF /auth/exchange handshake completed");
      })
      .catch((err) => {
        handshakeStarted = false;
        logger.error("BFF /auth/exchange handshake failed", err);
      });
  }

  onMount(async () => {
    logger.info("Initializing import-installations-ui ...");

    await asyncPing();
    appStatus = "authenticating";
    startHandshake();
  });

  const asyncPing = async () => {
    try {
      logger.info("Waking up backend by ping...");
      const response = await fetch(`${API_HOST}/ping`);
      if (!response.ok) {
        throw new Error(`Ping failed with status: ${response.status}`);
      }
      logger.info("Backend is alive");
    } catch (error) {
      logger.error("Error pinging backend:", error);
    }
  };
</script>

<main>
  <div class="relative">
    <div class:blur-sm={appStatus !== "ready"}>
      <ImportInstallationsPage props={containerAttributes} />
    </div>

    {#if appStatus !== "ready"}
      <div
        class="absolute inset-0 z-10 grid place-items-center bg-white/60"
      >
        <div class="card shadow">{overlayText}</div>
      </div>
    {/if}
  </div>
</main>
